export const OPERATIONAL_HOLD_FIELD = 'operationalHold';

export const OPERATIONAL_HOLD_REASONS = Object.freeze([
  { value: 'payment_default', label: 'Mancato pagamento' },
  { value: 'non_responsive', label: 'Non risponde' },
  { value: 'admin_pause', label: 'Pausa amministrativa' },
  { value: 'other', label: 'Altro' },
]);

const REASON_LABELS = OPERATIONAL_HOLD_REASONS.reduce((acc, item) => {
  acc[item.value] = item.label;
  return acc;
}, {});

const trimString = (value) => String(value || '').trim();

const pickHoldSource = (value = {}) => {
  if (
    value &&
    typeof value === 'object' &&
    value[OPERATIONAL_HOLD_FIELD] !== undefined &&
    value[OPERATIONAL_HOLD_FIELD] !== null
  ) {
    return value[OPERATIONAL_HOLD_FIELD];
  }
  return value;
};

export function normalizeOperationalHold(value = {}) {
  const source = pickHoldSource(value);

  if (source === true) {
    return {
      active: true,
      reason: '',
      note: '',
      hideFromOperationalLists: true,
      suppressNotifications: true,
      createdAt: null,
      createdBy: null,
      updatedAt: null,
      updatedBy: null,
      clearedAt: null,
      clearedBy: null,
    };
  }

  if (!source || typeof source !== 'object') {
    return {
      active: false,
      reason: '',
      note: '',
      hideFromOperationalLists: false,
      suppressNotifications: false,
      createdAt: null,
      createdBy: null,
      updatedAt: null,
      updatedBy: null,
      clearedAt: null,
      clearedBy: null,
    };
  }

  const active = source.active === true ||
    source.status === 'active' ||
    source.operationalHoldActive === true;
  const hideFromOperationalLists = source.hideFromOperationalLists ??
    source.operationalHoldHideFromOperationalLists;
  const suppressNotifications = source.suppressNotifications ??
    source.operationalHoldSuppressNotifications;

  return {
    active,
    reason: trimString(source.reason || source.operationalHoldReason),
    note: trimString(source.note || source.operationalHoldNote),
    hideFromOperationalLists: active && hideFromOperationalLists !== false,
    suppressNotifications: active && suppressNotifications !== false,
    createdAt: source.createdAt || null,
    createdBy: source.createdBy || null,
    updatedAt: source.updatedAt || null,
    updatedBy: source.updatedBy || null,
    clearedAt: source.clearedAt || null,
    clearedBy: source.clearedBy || null,
  };
}

export function isOperationalHoldActive(value = {}) {
  return normalizeOperationalHold(value).active;
}

export function shouldHideFromOperationalLists(value = {}) {
  return normalizeOperationalHold(value).hideFromOperationalLists;
}

export function shouldSuppressNotifications(value = {}) {
  return normalizeOperationalHold(value).suppressNotifications;
}

export function getOperationalHoldReasonLabel(value = '') {
  const reason = trimString(value);
  return REASON_LABELS[reason] || reason || 'Sospensione operativa';
}

export function getOperationalHoldSummary(value = {}) {
  const hold = normalizeOperationalHold(value);
  if (!hold.active) return '';
  const label = getOperationalHoldReasonLabel(hold.reason);
  return hold.note ? `${label} - ${hold.note}` : label;
}

export function mapOperationalHoldIndexFields(data = {}) {
  const hold = normalizeOperationalHold(data);
  return {
    operationalHold: hold,
    operationalHoldActive: hold.active,
    operationalHoldReason: hold.reason || '',
    operationalHoldNote: hold.note || '',
    operationalHoldHideFromOperationalLists: hold.hideFromOperationalLists,
    operationalHoldSuppressNotifications: hold.suppressNotifications,
  };
}
